import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

export default function SplitTable(props) {
  const half = Math.ceil(props.data.length / 2);
  const createTable = (rows) => {
    return (
      <Table size="small">
        <TableBody>
          {rows.map((d, index) => (
            <TableRow key={index}>
              <TableCell>{d}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        {props.label}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          {createTable(props.data.slice(0, half))}
        </Grid>
        <Grid item xs={6}>
          {createTable(props.data.slice(half))}
        </Grid>
      </Grid>
    </Paper>
  );
}
